import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquare, Calendar } from "lucide-react";
import { siteInfo } from "../../mock";
import logo from "../../data/images/logo.png";
import { openWeaveBookingInNewTab, WEAVE_BOOKING_URL } from "../../lib/weaveBooking";

const Header = () => {
  return (
    <header className="bg-[#F6EEDC] border-b border-[#D8C29A]/24 shadow-[0_1px_0_rgba(216,194,154,0.08)]">
      <div className="max-w-7xl mx-auto pl-4 pr-6 md:px-6 py-4 md:py-5 grid grid-cols-3 md:grid-cols-[1fr_auto_1fr] items-center gap-3 md:gap-6">
        <div className="hidden md:flex md:justify-start md:order-1">
          <a
            href={WEAVE_BOOKING_URL}
            onClick={openWeaveBookingInNewTab}
            className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-gradient-to-b from-[#D8C29A] to-[#B89468] hover:from-[#E4D2B1] hover:to-[#C7A97B] text-[#ffffff] px-4 md:px-5 py-2 md:py-2.5 uppercase text-[10px] md:text-[11px] tracking-[0.2em] font-semibold font-cinzel transition-all shadow-[0_8px_18px_-10px_rgba(184,148,104,0.45)]"
          >
            <Calendar size={14} className="shrink-0" />
            Book a Consult
          </a>
        </div>

        <div className="col-span-3 md:col-span-1 flex items-center justify-center gap-[10px] order-1 md:order-2">
          <Link
            to="/"
            className="font-script text-2xl md:text-4xl text-[#8A6A2B] hover:text-[#A9823A] transition-colors leading-none"
          >
            Galleria
          </Link>
          <Link to="/" className="flex items-center justify-center">
            <img
              src={logo}
              alt="Galleria Dental"
              className="h-12 md:h-14 w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="font-script text-2xl md:text-4xl text-[#8A6A2B] hover:text-[#A9823A] transition-colors leading-none"
          >
            Dental
          </Link>
        </div>

        <div className="hidden md:flex items-center md:justify-end gap-3 md:order-3">
          <a
            href={`tel:${siteInfo.phoneRaw}`}
            className="inline-flex items-center gap-2 text-[#3A3127] hover:text-[#9A7A52] transition-colors"
          >
            <span className="w-9 h-9 rounded-full border border-[#D8C29A] flex items-center justify-center bg-white/78">
              <Phone size={15} className="text-[#9A7A52]" />
            </span>
            <span className="font-cinzel text-sm md:text-base tracking-wider">{siteInfo.phone}</span>
          </a>
          <a
            href={`sms:${siteInfo.phoneRaw}`}
            className="inline-flex w-9 h-9 rounded-full border border-[#D8C29A] items-center justify-center text-[#9A7A52] hover:bg-[#D8C29A] hover:text-[#ffffff] transition-colors bg-white/58"
            aria-label="Message"
          >
            <MessageSquare size={15} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
